export { default as locationsReducers } from 'locations/reducers/locations_reducers';



// WEBPACK FOOTER //
// src/modules/secured/modules/locations/reducers/index.js